import { createStyles } from 'antd-style';

export const useHeaderStyles = createStyles(({ token, css, responsive }) => ({
  container: css`
    color: #efefef;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-left: ${token.margin}px;
  `,
  logo: css`
    color: white;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: ${token.adminHeaderHeight}px;
    flex-shrink: 0;
    width: ${token.adminSiderWitdh}px;
    transition:
      width 0.2s,
      opacity 0.2s;
    overflow: hidden;
    opacity: 1;
    &.collapsed {
      width: 0;
      opacity: 0;
    }
    ${responsive.xs} {
      display: none;
    }
  `,

  logoInner: css`
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 36px;
    }
    span {
      color: #fff;
      font-size: 24px;
      padding-left: 10px;
    }
  `,
  left: css`
    display: flex;
    align-items: center;
  `,
  login: css`
    padding-right: 25px;
    display: flex;
    gap: 15px;
    align-items: center;
  `,
  user: css`
    cursor: pointer;
    color: #fff;
  `,

  avatar: css`
    width: 32px;
    border-radius: 50%;
    margin-right: 5px;
  `,
  logout: css`
    cursor: pointer;
    &:hover {
      color: red;
    }
  `,
  menuToggleTrigger: css`
    font-size: 18px;
    padding: 0 24px 0 0;
    cursor: pointer;
    transition: color 0.3s;
    color: #fff;
  `,
}));
